import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: {
    selectedProfileImage: null,
    croppedProfileImage: null,
    isProfileImageModalOpen: false,
    isProfileImageDeleteOpen: false,
  },
};

const profileImageSlice = createSlice({
  name: "profileImage",
  initialState,
  reducers: {
    updateProfileImageData: (state, action) => {
      state.data = { ...state.data, ...action.payload };
    },
  },
});

export const { updateProfileImageData } = profileImageSlice.actions;

export default profileImageSlice.reducer;
